import React, { useState, useRef, useEffect } from 'react';
import Overlay from 'react-bootstrap/Overlay';
import Popover from 'react-bootstrap/Popover';
import { Stack } from 'react-bootstrap';
import { Avatar, Box, Chip, Tooltip, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';

const OutboundItemList = (props) => {
    const { outbound, canView, handleView } = props;
    const [show, setShow] = useState(false);
    const target = useRef(null);
    const popoverRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                popoverRef.current &&
                !popoverRef.current.contains(event.target) &&
                target.current &&
                !target.current.contains(event.target)
            ) {
                setShow(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const popover = (
        <Popover id="popover-basic" className='popoverOutbound' ref={popoverRef}>
            <Popover.Body>
                <div className='popoverOutbound__title mb-1'>Outbound Items</div>
                <div className='popoverOutbound__body'>
                    <div className="itemListBody">
                        {outbound?.items?.map((item, index) => (
                            <div key={item?.id} className='popoverOutbound__item displayFlex mb-1 pb-1 pt-1'>
                                <img src={item?.thumbnailUrl} alt="item" className="outbound_item_image mr-1" />
                                <div className="outbound_item_list__title ml-2 mr-2">
                                    <div className='pudctName'>{item.name}</div>
                                    <div className='pdSku'>{item.productSKU}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                {canView && (
                    <div className='mt-1 alignRight pr-0'>
                        <button className='btn cus-primary-transparent-btn p-1 viewBtn' onClick={handleView}>View</button>
                    </div>
                )}
            </Popover.Body>
        </Popover>
    );

    return (
        <div className="outbound-item-list">
            <button
                ref={target}
                onClick={() => setShow(!show)}
                className="outbound_item_wrapper sortBtn"
            >

                <div className="outbound_item_details">
                    <div className="outbound_item_list__title mr-2 maxwidth">
                        <Stack direction="row" >
                            {outbound?.items?.length && outbound?.items.slice(0, 5).map((item, index) => (
                                <Chip
                                    key={item?.id}
                                    avatar={<Avatar title='Ordered Quantity'>{item.orderedQuantity}</Avatar>}
                                    label={
                                        <Tooltip title={item.name} placement="top" arrow>
                                            <Box
                                                sx={{
                                                    maxWidth: 50,
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap',
                                                }}
                                            >
                                                <Typography variant="body2" noWrap>
                                                    {item.name}
                                                </Typography>
                                            </Box>
                                        </Tooltip>
                                    }
                                />
                            ))}
                        </Stack>
                        {outbound?.items?.length > 5 && (
                            <p className="moreItems">{outbound.items.length - 5} More Items</p>
                        )}
                    </div>
                </div>
                <div className='outbound-item-list__actions'>
                    <i className="fa fa-caret-down" aria-hidden="true"></i>
                </div>
            </button>

            <Overlay
                target={target.current}
                show={show}
                placement="bottom"
                containerPadding={10}
            >
                {(props) => (
                    <div
                        ref={popoverRef}
                        {...props}
                        style={{
                            ...props.style,
                            zIndex: 9,
                            position: 'absolute',
                        }}
                    >
                        {popover}
                    </div>
                )}
            </Overlay>
        </div>
    );
};

OutboundItemList.propTypes = {
    outbound: PropTypes.object.isRequired,
    canView: PropTypes.bool.isRequired,
    handleView: PropTypes.func.isRequired,
    style: PropTypes.object,
};

export default OutboundItemList;